module.exports = __webpack_public_path__ + "img/dz-icon.95b6891c.svg";